(function() {
  const sections = document.querySelectorAll('.bigmad-collection');
  if (!sections.length) return;

  sections.forEach(section => {
    const grid = section.querySelector('[data-product-grid]');
    const filterForm = section.querySelector('[data-filter-form]');
    const sortSelect = section.querySelector('[data-sort-select]');
    const sidebar = section.querySelector('[data-filter-sidebar]');
    const overlay = section.querySelector('[data-filter-overlay]');
    const filterToggle = section.querySelector('[data-filter-toggle]');
    let filterClose = section.querySelector('[data-filter-close]');

    if (!grid || !filterForm) return;

    let isLoading = false;
    let debounceTimer = null;

    // ========== SIDEBAR DRAWER ==========
    function openSidebar() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      sidebar.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-active');
      document.body.classList.add('bigmad-collection-locked');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    }

    function closeSidebar() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      sidebar.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('bigmad-collection-locked');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    }

    function toggleSidebar() {
      if (sidebar?.classList.contains('is-open')) {
        closeSidebar();
      } else {
        openSidebar();
      }
    }

    if (filterToggle) filterToggle.addEventListener('click', toggleSidebar);
    if (filterClose) filterClose.addEventListener('click', closeSidebar);
    if (overlay) overlay.addEventListener('click', closeSidebar);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && sidebar?.classList.contains('is-open')) closeSidebar();
    });

    // ========== AJAX FILTER + SORT ==========
    async function fetchFiltered(url, pushState = true, closeAfter = false) {
      if (isLoading) return;
      isLoading = true;
      grid.classList.add('is-loading');

      try {
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error('Filter fetch failed');
        const html = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Substitui o grid
        const newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid) {
          grid.innerHTML = newGrid.innerHTML;
        }

        // Substitui os chips da topbar
        const newChips = doc.querySelector('[data-topbar-chips]');
        const currentChips = section.querySelector('[data-topbar-chips]');
        if (newChips && currentChips) {
          currentChips.innerHTML = newChips.innerHTML;
          attachChipEvents();
        }

        // Atualiza o badge de contagem no botão de filtro
        const newBadge = doc.querySelector('[data-filter-count-badge]');
        const currentBadge = section.querySelector('[data-filter-count-badge]');
        if (newBadge) {
          if (currentBadge) {
            currentBadge.textContent = newBadge.textContent;
          } else if (filterToggle) {
            // cria o badge se não existia
            filterToggle.insertAdjacentHTML('beforeend', newBadge.outerHTML);
          }
        } else if (currentBadge) {
          currentBadge.remove();
        }

        // Substitui sidebar mantendo o estado de scroll
        const newSidebar = doc.querySelector('[data-filter-sidebar]');
        if (newSidebar && sidebar) {
          const wasOpen = sidebar.classList.contains('is-open');
          const sidebarInner = sidebar.querySelector('.bigmad-collection-sidebar-inner');
          const scrollPos = sidebarInner ? sidebarInner.scrollTop : 0;

          sidebar.innerHTML = newSidebar.innerHTML;

          // Mantém aberto só se não for pra fechar
          if (wasOpen && !closeAfter) {
            sidebar.classList.add('is-open');
            sidebar.setAttribute('aria-hidden', 'false');
          }

          const newSidebarInner = sidebar.querySelector('.bigmad-collection-sidebar-inner');
          if (newSidebarInner) newSidebarInner.scrollTop = scrollPos;

          attachFilterEvents();
          attachSidebarEvents();
        }

        // Atualiza URL no histórico
        if (pushState) {
          window.history.pushState({}, '', url);
        }

        // Fecha a aba se solicitado (ao aplicar filtro)
        if (closeAfter) {
          closeSidebar();
        }

      } catch (err) {
        console.error('Filter error:', err);
      } finally {
        grid.classList.remove('is-loading');
        isLoading = false;
      }
    }

    function getFilterUrl() {
      const form = section.querySelector('[data-filter-form]');
      if (!form) return window.location.pathname;

      const formData = new FormData(form);
      const params = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        if (value && value !== '') {
          params.append(key, value);
        }
      }

      const baseUrl = window.location.pathname;
      const queryString = params.toString();
      return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    }

    // Aplica filtro E FECHA a aba (pedido do usuário)
    function triggerFilter() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchFiltered(getFilterUrl(), true, true);
      }, 250);
    }

    function attachFilterEvents() {
      const inputs = section.querySelectorAll('[data-filter-input]');
      inputs.forEach(input => {
        // Checkbox/swatch: fecha a aba ao mudar
        // Preço (number): não fecha imediato (deixa digitar), fecha no blur
        if (input.matches('[data-filter-price]')) {
          input.addEventListener('change', triggerFilter);
        } else {
          input.addEventListener('change', triggerFilter);
        }
      });
    }

    function attachSidebarEvents() {
      const newClose = section.querySelector('[data-filter-close]');
      if (newClose) {
        newClose.addEventListener('click', closeSidebar);
        filterClose = newClose;
      }
    }

    // Eventos dos chips (na topbar) — removem filtro sem fechar nada
    function attachChipEvents() {
      section.querySelectorAll('[data-filter-chip]').forEach(chip => {
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          fetchFiltered(chip.href, true, false);
        });
      });

      const clearAll = section.querySelector('[data-filter-clear-all]');
      if (clearAll) {
        clearAll.addEventListener('click', (e) => {
          e.preventDefault();
          fetchFiltered(clearAll.href, true, false);
        });
      }
    }

    attachFilterEvents();
    attachSidebarEvents();
    attachChipEvents();

    // SORT — não fecha a aba (a aba nem está aberta normalmente)
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const newSortInput = section.querySelector('[data-sort-input]');
        if (newSortInput) newSortInput.value = sortSelect.value;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          fetchFiltered(getFilterUrl(), true, false);
        }, 100);
      });
    }

    // BACK/FORWARD do navegador
    window.addEventListener('popstate', () => {
      fetchFiltered(window.location.href, false, false);
    });

    // ========== LOAD MORE ==========
    async function loadMore() {
      const pagination = section.querySelector('[data-pagination]');
      const wrap = section.querySelector('[data-loadmore-wrap]');
      const btn = wrap?.querySelector('[data-loadmore]');
      if (!btn || isLoading) return;

      const nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;

      isLoading = true;
      btn.classList.add('is-loading');
      btn.disabled = true;

      try {
        const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error('Load more failed');
        const html = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-product-grid]');
        if (!newGrid) return;

        // Pega os cards novos (ignora os elementos auxiliares)
        const newCards = Array.from(newGrid.children).filter(child =>
          !child.matches('[data-pagination]') &&
          !child.matches('.bigmad-collection-empty')
        );

        // Pega a paginação nova (pra atualizar contador + barra + botão)
        const newPagination = doc.querySelector('[data-pagination]');

        // Remove a paginação atual
        if (pagination) pagination.remove();

        // Adiciona os novos cards no final do grid
        newCards.forEach(card => grid.appendChild(card));

        // Adiciona a nova paginação (com contador atualizado)
        if (newPagination) {
          grid.appendChild(newPagination);
          const newBtn = newPagination.querySelector('[data-loadmore]');
          if (newBtn) newBtn.addEventListener('click', loadMore);
        }

      } catch (err) {
        console.error('Load more error:', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
      } finally {
        isLoading = false;
      }
    }

    // Anexa load more inicial
    const initialLoadMore = section.querySelector('[data-loadmore]');
    if (initialLoadMore) {
      initialLoadMore.addEventListener('click', loadMore);
    }

  });
})();
